import clsx from 'clsx'

/**
 * Migration notice shown on every page, announcing the ModernMT → Lara
 * transition. Mirrors the strip on the marketing site (website-frontend).
 *
 * Its height is driven by the `--migration-strip-height` CSS variable defined
 * in `app/tailwind.css`; the full-height page layouts subtract that same
 * variable (via the `.h-below-strip` / `.min-h-below-strip` utilities) so the
 * strip pushes content down instead of overlapping it.
 */
export const MigrationStrip = ({className}: {className?: string}) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-center text-center',
        'min-h-[var(--migration-strip-height)] px-4 py-1',
        'bg-[#f6b30a] text-black text-sm font-bold leading-tight',
        className,
      )}
    >
      <span>
        ModernMT is evolving into Lara and will sunset by the end of 2026.&nbsp;
        <a
          href="/#how-to-migrate"
          className="whitespace-nowrap underline hover:no-underline"
        >
          Learn more
        </a>
      </span>
    </div>
  )
}
